var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#56l50px6ma)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.333 12.266c.736 0 1.333-.597 1.333-1.334v-6h-3.333A1.333 1.333 0 0 1 10 3.6V.266H6.666c-.736 0-1.333.597-1.333 1.333v2H6.39c.177 0 .347.07.472.195l4.276 4.276a.667.667 0 0 1 .195.472v3.724h2zM10.666.588v2.678a1 1 0 0 0 1 1h2.678a.133.133 0 0 0 .095-.228L10.894.493a.133.133 0 0 0-.228.095zm0 14.344c0 .737-.597 1.334-1.333 1.334H2.666a1.333 1.333 0 0 1-1.333-1.334V5.6c0-.736.597-1.333 1.333-1.333H6v3.333c0 .736.597 1.333 1.333 1.333h3.333v6zm-4-7.666V4.588c0-.12.144-.179.228-.095l3.545 3.545a.133.133 0 0 1-.095.228H7.667a1 1 0 0 1-1-1z",
    fill: "#6B47F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "56l50px6ma"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .266)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyInputIcon);
export default __webpack_public_path__ + "static/media/copy-input-icon.b4589295844642966de5860485e8b7c0.svg";
export { ForwardRef as ReactComponent };